import React, { useState } from "react";
import DetailPage from "../../../../../../article/pages/details";
import { AffiliateJoinData } from "../../../network/api/AffiliateJoinData";
import ButtonLoader from "../../../../../../../components/ButtonLoader";
import Alerts from "../../../../../../../components/Alerts";


export default function Join({userId, setIsUserPartner }) {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const joinAffiliate = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrorMessage(null);
        try {
            const response = await AffiliateJoinData();
            if (response.status === "success") {
                setErrorMessage({
                    status: "success",
                    message: response.message || "You have successfully joined the affiliate program."
                });
                setTimeout(() => {
                    setIsUserPartner(true); 
                }, 2000); 
            }
            else {
                setErrorMessage({
                    status: "danger",
                    message: response.message || "An error occurred while trying to join the affiliate program."
                });
            }

        } catch (error) {
            setErrorMessage({
                status: "danger",
                message: "An error occurred while trying to join the affiliate program. Please try again later."
            });
        }
        setIsLoading(false);
    }

    if (userId) {
        //user is not an affiliate and you can not join affiliate for them
        return (
            <div className="container-fluid" key={`join-affiliate`}>
                <div className="row justify-content-center align-items-center" style={{ height: "80vh" }}>
                    <div className="col-auto text-center">
                        <div className="alert alert-warning mb-3" role="alert">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            You are not allowed to join the affiliate program for this user.
                        </div>
                        <p className="text-muted">Please log in as the user to join the affiliate program.</p>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <>
            <DetailPage slugI={"partner-terms"} />
            <div className="container-fluid" key={`join-affiliate-${userId}`}>
                <div className="row ">
                    <div className="col-12">
                        <div className="justify-content-between align-items-center ">
                            <div className="d-flex justify-content-center">
                                <div className="col-lg-8 col-12 card custom-card p-4">
                                    {!isLoading && errorMessage ?
                                                    <Alerts type={errorMessage.status === "success" ? "success" : "danger"} message={errorMessage.message} />
                                                    : <></>}
                                    <div className="text-center">
                                        <form className="mt-4" onSubmit={(e)=>joinAffiliate(e)}>
                                            <div className="form-check d-flex align-items-center justify-content-center mb-3">
                                                <input type="checkbox" className="form-check-input me-2" id="agreeTerms" required />
                                                <label className="form-check-label mb-0" htmlFor="agreeTerms">
                                                    I agree to the terms and conditions
                                                </label>
                                            </div>
                                            <div className="text-center">
                                                <button type="submit" className="btn btn-primary w-100" disabled={isLoading} >
                                                    {
                                                     isLoading ? (<ButtonLoader />) : (<>
                                                            <i className="fas fa-user-plus me-2"></i>
                                                            I Want to Become a Partner
                                                        </>
                                                        )
                                                    }
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}